import { useMemo } from 'react';
import {
  CloudServerOutlined,
  DatabaseOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FolderOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { CellContext } from '@tanstack/react-table';
import styled from 'styled-components';
import { useFileExplorerContext } from './FileExplorerContext';

export const fileExplorerTypesMap = {
  drive: DatabaseOutlined,
  folder: FolderOutlined,
  pdf: FilePdfOutlined,
  doc: FileWordOutlined,
  presentation: FilePptOutlined,
  image: FileImageOutlined,
  page: FileTextOutlined,
  site: CloudServerOutlined,
  space: GlobalOutlined,
  default: FileOutlined,
};

const NameCellContainer = styled('div')<{ isClickable?: boolean }>`
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .anticon {
    font-size: 24px;
    margin-right: 8px;
  }
`;

export function FileExplorerNameCell<TData>({
  row: { original: item },
}: CellContext<TData, unknown>) {
  const {
    onRowClick,
    isRowClickable,
    rowNameKey,
    rowTypeKey,
    getRowName,
    getRowTypeIcon,
  } = useFileExplorerContext<TData>();
  const rowType = item[rowTypeKey] as keyof typeof fileExplorerTypesMap;
  const Icon = fileExplorerTypesMap[rowType] ?? fileExplorerTypesMap.default;
  const isClickable = useMemo(
    () => isRowClickable?.(item),
    [isRowClickable, item],
  );

  return (
    <NameCellContainer
      isClickable={isClickable}
      onClick={() => isClickable && onRowClick?.(item)}
    >
      {getRowTypeIcon?.(item) ?? <Icon />}
      {getRowName?.(item) ?? String(item[rowNameKey])}
    </NameCellContainer>
  );
}
